import { $, listen } from "@olmokit/dom";
import { getUrlQueryParams } from "@olmokit/utils/getUrlQueryParams";
import Dialog, { udpdateDeeplink } from "components/Dialog/Base";
import "./index.scss";

/** dialog id */
export const id = "dialog-video";

/**
 * Component: Dialog video
 */
function DialogVideo() {
  if (!$(".DialogVideo:")) {
    return;
  }

  let player;
  const dialog = Dialog(
    ".DialogVideo:",
    {
      id,
    },
    {
      opened: handleOpen,
      closing: handleClosing,
    }
  );

  import("@olmokit/core/player").then((module) => {
    player = module.default($(".video-js", dialog.$content));
  });

  /**
   * Handle dialog open
   */
  function handleOpen() {
    if (player) player.play();
    udpdateDeeplink(id, true);
  }

  /**
   * Handle dialog closing
   */
  function handleClosing() {
    if (player) player.pause();
    udpdateDeeplink(id, false);
  }

  return dialog;
}

/** dialog instance */
export const instance = DialogVideo();

/** dialog auto initialiser */
export default function initDialogVideo() {
  if (!$(".DialogVideo:")) {
    return;
  }

  const queryParams = getUrlQueryParams();

  listen("click", `[data-${id}]`, handleClick);

  if (queryParams[id]) {
    instance.open();
  }

  /** @param {MouseEvent} event */
  function handleClick(event) {
    event.preventDefault();
    instance.open();
  }
}
